import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton, { ListItemButtonProps } from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { SxProps, Tooltip, Theme, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";

type ComponentProps = {
  text: string | React.ReactNode;
  icon: React.ReactNode;
  iconLocation?: "start" | "end";
  collapsed?: boolean;
  sx?: SxProps<Theme>;
  tooltipText?: string | React.ReactNode;
  target?: string;
  rel?: string;
  href?: string;
};

function NavBarButton({
  text,
  icon,
  iconLocation = "start",
  collapsed = false,
  tooltipText = text !== null ? text : "",
  sx,
  // target = "",
  // rel = "",
  // href = "",
  ...rest
}: ComponentProps & ListItemButtonProps) {
  const theme = useTheme();

  return (
    <Tooltip
      arrow={true}
      title={!collapsed && tooltipText !== "" && <Typography variant="body1">{tooltipText}</Typography>}
      placement="right"
    >
      <ListItem disablePadding sx={{ display: "block" }}>
        <ListItemButton
          sx={{
            minHeight: 48,
            justifyContent: "center",
            flexDirection: iconLocation === "start" ? "row" : "row-reverse",
            px: 2.5,
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.dark,
              fontWeight: 900,
            },
            ...sx,
          }}
          {...rest}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: collapsed ? 0 : 1,
              justifyContent: "center",
            }}
          >
            {icon}
          </ListItemIcon>
          <ListItemText primary={text} sx={{ display: collapsed ? "none" : "initial" }} />
        </ListItemButton>
      </ListItem>
    </Tooltip>
  );
}

export default NavBarButton;
